/**
 * Created by michaelc on 5/8/2017.
 */

window.__env = window.__env || {};

window.__env.remoteRest = {
    protocol: "http",
    host: "localhost",
    port: "8016",
    route: "",
};
window.__env.remoteGenieRest = {
    protocol: "http",
    host: "localhost",
    port: "8019",
    route: "",
};
window.__env.error_route = window.__env.remoteRest.protocol + "://" + window.__env.remoteRest.host + ":" + window.__env.remoteRest.port + "/Logger/LogItem";
window.__env.config = {
    timeout: 60000,
    versionRM: "24.3.1.11998",
    jobsNormalInterval: 5000,
    jobsSpeedInterval: 5000,
    onlineDocLink: "https://id.atlassian.com/login?continue=https%3A%2F%2Fdbmaestro.atlassian.net%2Flogin%3FredirectCount%3D1%26dest-url%3D%252Fwiki%252Fspaces%252FDBm20Docs%252Foverview%26application%3Dconfluence&application=confluence",
    secureCookie: false,
    oidcUserNameTokenKey: "upn",
    showDashboard: false

};

window.__env.enableDebug = true;



// WEBPACK FOOTER //
// ./src/env.js